import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.scss';
import Portal from 'portal/Portal';
import Header from 'components/Header';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackSharpIcon from '@material-ui/icons/ArrowBackSharp';

const useStyles = makeStyles(theme => ({
  formContainerColor: {
    // height: SUB_FORM_CONTAINER.height,
    overflow: 'auto',
    background: theme.palette.background.default,
  },
}));

const FormPopup = ({
  headerTitle,
  form,
  className,
  closePopup,
  usePortal,
  onSaveClick,
  isSaveRequired,
}) => {
  const classes = useStyles();
  const display = usePortal => {
    if (usePortal) {
      return (
        <Portal id={'portal'}>
          <Box
            className={cn(
              styles.formContainer,
              className,
              classes.formContainerColor,
            )}
          >
            <Header
              title={headerTitle}
              icon={ArrowBackSharpIcon}
              onClick={closePopup}
              onSaveClick={onSaveClick}
              isSaveRequired={isSaveRequired}
            />
            <div className={styles.formPadding}>{form}</div>
          </Box>
        </Portal>
      );
    } else {
      return (
        <div>
          <div className={cn(styles.formContainer, className)}>
            <Header
              title={headerTitle}
              icon={ArrowBackSharpIcon}
              onClick={closePopup}
              onSaveClick={onSaveClick}
            />
            <div className={styles.formPadding}>{form}</div>
          </div>
        </div>
      );
    }
  };
  return display(usePortal);
};
FormPopup.defaultProps = {
  usePortal: true,
};

FormPopup.propTypes = {
  headerTitle: PropTypes.string,
  form: PropTypes.element,
  className: PropTypes.string,
  closePopup: PropTypes.func,
  onSaveClick: PropTypes.func,
  isSaveRequired: PropTypes.bool,
};
export default FormPopup;
